import * as React from 'react';

import NoEntities from '../../shared/NoEntities';

const NoCharacters: React.FunctionComponent = () => {
  return <NoEntities>登録したキャラクターがありません</NoEntities>;
};

export default React.memo(NoCharacters);
